module.exports = __webpack_public_path__ + "static/media/2.047e133f.jpg";